"use client";

import { ConfirmProvider } from "@/components/material-ui-confirm";
import theme from "@/styles/theme";
import { ThemeProvider } from "@emotion/react";
import CssBaseline from "@mui/material/CssBaseline";
import { StyledEngineProvider } from "@mui/material/styles";
import { IntlProvider } from "react-intl";
import { RecoilRoot } from "recoil";

export default function PlayerWidgetLayout({ children }) {
  return (
    <>
      <IntlProvider locale="de" defaultLocale="de">
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <RecoilRoot>
              <ConfirmProvider>{children}</ConfirmProvider>
            </RecoilRoot>
          </ThemeProvider>
        </StyledEngineProvider>
      </IntlProvider>
    </>
  );
}
